import { FC } from 'react';

import { FiX } from 'react-icons/fi';

import { Container } from './styles';

import { Tooltip } from '../../Tooltip';

interface IModalHeaderProps {
  id?: string;
  title: string;
  onClose(closeOnX: boolean): void;
}

export const ModalHeader: FC<IModalHeaderProps> = ({ id, onClose, title }) => {
  return (
    <Container>
      <h2 id={id}>{title}</h2>

      <Tooltip label="Fechar">
        <button type="button" onClick={() => onClose(true)}>
          <FiX />
        </button>
      </Tooltip>
    </Container>
  );
};
